"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRdProjectCategory = void 0;
const selected_rd_project_category_enum_1 = require("./enums/selected-rd-project-category.enum");
const calculateRdProjectCategory = ({ consideredForRd, isSection174Eligible, }) => {
    if (consideredForRd) {
        return selected_rd_project_category_enum_1.SelectedRdProjectCategory.RD_CREDIT;
    }
    if (isSection174Eligible) {
        return selected_rd_project_category_enum_1.SelectedRdProjectCategory.SECTION_174_ONLY;
    }
    return selected_rd_project_category_enum_1.SelectedRdProjectCategory.EXCLUDED;
};
exports.calculateRdProjectCategory = calculateRdProjectCategory;
